module.exports = __webpack_public_path__ + "img/card.c8f47ae6.svg";